function slotShouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
export {
  slotShouldForwardProp as default
};
//# sourceMappingURL=slotShouldForwardProp.es.js.map
